const { calculateTier, buildCartItems, buildWhatsAppText } = window.UniformeLogic

const money = (cents) => (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

function track(eventName, payload = {}) {
  if (window.dataLayer) window.dataLayer.push({ event: eventName, ...payload })
  if (window.fbq) window.fbq('trackCustom', eventName, payload)
}

const PERSO_DEFAULTS = {
  enabled: true,
  label: 'Quero personalizar — bordado no peito (~5×5 cm)',
  variantIdUpTo: '52711883440415',
  variantIdAbove: '52711883473183',
  breakQty: 51,
  priceUpToCents: 1800,
  priceAboveCents: 800,
  whatsappHint: 'Para bordado grande, estampa ou outras técnicas, fale com um consultor →'
}

function initConfigurator(root) {
  const dataEl = root.querySelector('#uniforme-config-data')
  if (!dataEl) return
  const data = JSON.parse(dataEl.textContent)

  // Merge com defaults — funciona mesmo sem bloco Personalização configurado
  const p = data.personalization || {}
  data.personalization = {
    enabled: true,
    label: p.label && p.label.trim() ? p.label : PERSO_DEFAULTS.label,
    variantIdUpTo: p.variantIdUpTo || PERSO_DEFAULTS.variantIdUpTo,
    variantIdAbove: p.variantIdAbove || PERSO_DEFAULTS.variantIdAbove,
    breakQty: p.breakQty || PERSO_DEFAULTS.breakQty,
    priceUpToCents: p.priceUpToCents || PERSO_DEFAULTS.priceUpToCents,
    priceAboveCents: p.priceAboveCents || PERSO_DEFAULTS.priceAboveCents,
    whatsappHint: p.whatsappHint && p.whatsappHint.trim() ? p.whatsappHint : PERSO_DEFAULTS.whatsappHint
  }

  const state = {
    grids: data.products.map(p => ({
      productTitle: p.color,
      blockId: p.blockId,
      sizes: p.variants.map(v => ({
        variantId: v.id, size: v.size, available: v.available, qty: 0
      }))
    })),
    personalization: { enabled: false, description: '' }
  }

  const panel = {
    unitPrice: root.querySelector('[data-panel-unit-price]'),
    tier: root.querySelector('[data-panel-tier]'),
    unlock: root.querySelector('[data-panel-unlock]'),
    totalQty: root.querySelector('[data-panel-total-qty]'),
    subtotal: root.querySelector('[data-panel-subtotal]'),
    cta: root.querySelector('[data-panel-cta]'),
    wa: root.querySelector('[data-panel-whatsapp]'),
    error: root.querySelector('[data-panel-error]'),
    persoWrapper: root.querySelector('[data-panel-perso-wrapper]'),
    persoBody: root.querySelector('[data-panel-perso-body]'),
    persoToggle: root.querySelector('[data-panel-perso-toggle]'),
    persoDesc: root.querySelector('[data-panel-perso-desc]'),
    persoLabel: root.querySelector('[data-panel-perso-label]'),
    persoHint: root.querySelector('[data-panel-perso-hint]'),
    persoFile: root.querySelector('[data-panel-perso-file]'),
    persoFileLabel: root.querySelector('[data-panel-perso-file-label]'),
    persoFileRemove: root.querySelector('[data-panel-perso-file-remove]')
  }

  panel.persoWrapper.hidden = false
  panel.persoLabel.textContent = data.personalization.label
  if (panel.persoHint) {
    panel.persoHint.textContent = data.personalization.whatsappHint
    panel.persoHint.href = `https://wa.me/${data.labels.whatsappNumber || '5547984796022'}?text=${encodeURIComponent('Olá, preciso de personalização diferente (bordado grande, estampa, etc). Podem me ajudar?')}`
    panel.persoHint.hidden = false
  }

  function getPersonalizationCents(qty) {
    if (!state.personalization.enabled) return 0
    return qty >= data.personalization.breakQty
      ? data.personalization.priceAboveCents
      : data.personalization.priceUpToCents
  }

  let viewFired = false
  const io = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && !viewFired) {
      viewFired = true
      track('view_configurator')
    }
  }, { threshold: 0.3 })
  io.observe(root)

  let lastTierMin = null
  let addVariantTimer = null
  function trackAddVariantThrottled(payload) {
    clearTimeout(addVariantTimer)
    addVariantTimer = setTimeout(() => track('configurator_add_variant', payload), 400)
  }

  function totalQty() {
    return state.grids.reduce((s, g) => s + g.sizes.reduce((ss, r) => ss + r.qty, 0), 0)
  }

  function render() {
    const qty = totalQty()
    const { current, next, toNext } = calculateTier(qty, data.tiers)
    const persoCents = getPersonalizationCents(qty)
    const unit = current.priceCents + persoCents
    panel.unitPrice.textContent = money(unit)
    panel.tier.textContent = qty === 0 ? 'Escolha os tamanhos' : `Faixa: ${current.minQty}+ un`
    panel.totalQty.textContent = `${qty} un`
    panel.subtotal.textContent = money(unit * qty)

    if (next && qty > 0) {
      panel.unlock.hidden = false
      panel.unlock.textContent = `▲ Adicione ${toNext} un e economize ${money(current.priceCents - next.priceCents)} por peça`
    } else {
      panel.unlock.hidden = true
    }

    panel.cta.disabled = qty === 0
    panel.cta.textContent = qty === 0 ? 'Escolha ao menos 1 tamanho' : data.labels.ctaLabel

    if (lastTierMin !== null && current.minQty !== lastTierMin) {
      track('unlock_price_tier', { tier_min: current.minQty, unit_price_cents: current.priceCents })
    }
    lastTierMin = current.minQty

    updateWhatsAppLink()
  }

  function updateWhatsAppLink() {
    const text = buildWhatsAppText(state)
    panel.wa.href = `https://wa.me/${data.labels.whatsappNumber}?text=${encodeURIComponent(text)}`
  }

  root.querySelectorAll('[data-grid]').forEach(gridEl => {
    const blockId = gridEl.dataset.grid
    const grid = state.grids.find(g => g.blockId === blockId)
    gridEl.querySelectorAll('.uniforme-size-row').forEach(row => {
      const variantId = Number(row.dataset.variantId)
      const rowState = grid.sizes.find(s => s.variantId === variantId)
      const qtyInput = row.querySelector('[data-qty]')
      const inc = row.querySelector('[data-action="inc"]')
      const dec = row.querySelector('[data-action="dec"]')

      const setQty = (n) => {
        rowState.qty = Math.max(0, Math.min(999, n))
        qtyInput.value = rowState.qty
        render()
        trackAddVariantThrottled({ total_qty: totalQty() })
      }
      inc.addEventListener('click', () => { if (rowState.available) setQty(rowState.qty + 1) })
      dec.addEventListener('click', () => setQty(rowState.qty - 1))
      qtyInput.addEventListener('input', () => setQty(Number(qtyInput.value) || 0))
    })
  })

  const addColorBtn = root.querySelector('[data-add-color]')
  const hasMultipleColors = state.grids.length > 1

  root.querySelectorAll('[data-color-tab]').forEach(tab => {
    tab.addEventListener('click', () => {
      const targetId = tab.dataset.colorTab
      root.querySelectorAll('[data-color-tab]').forEach(t => {
        const active = t === tab
        t.classList.toggle('is-active', active)
        t.setAttribute('aria-selected', active ? 'true' : 'false')
      })
      root.querySelectorAll('[data-grid]').forEach(g => {
        g.classList.toggle('is-hidden', g.dataset.grid !== targetId)
      })
      // Restaurar botão "+ Adicionar segunda cor" ao voltar pro modo single-color
      if (addColorBtn && hasMultipleColors) {
        addColorBtn.hidden = false
      }
    })
  })

  if (addColorBtn && hasMultipleColors) {
    addColorBtn.hidden = false
    addColorBtn.addEventListener('click', () => {
      root.querySelectorAll('[data-grid]').forEach(g => g.classList.remove('is-hidden'))
      root.querySelectorAll('[data-color-tab]').forEach(t => {
        t.classList.add('is-active')
        t.setAttribute('aria-selected', 'true')
      })
      addColorBtn.hidden = true
    })
  }

  if (panel.persoToggle) {
    panel.persoToggle.addEventListener('change', () => {
      state.personalization.enabled = panel.persoToggle.checked
      if (panel.persoBody) panel.persoBody.hidden = !panel.persoToggle.checked
      render()
    })
    panel.persoDesc.addEventListener('input', () => {
      state.personalization.description = panel.persoDesc.value
      updateWhatsAppLink()
    })
    if (panel.persoFile) {
      panel.persoFile.addEventListener('change', () => {
        const f = panel.persoFile.files && panel.persoFile.files[0]
        if (!f) return
        if (f.size > 20 * 1024 * 1024) {
          alert('Arquivo maior que 20 MB. Envie uma versão menor ou pelo WhatsApp após o pedido.')
          panel.persoFile.value = ''
          return
        }
        state.personalization.file = f
        panel.persoFileLabel.textContent = `📎 ${f.name} (${(f.size / 1024 / 1024).toFixed(1)} MB)`
        panel.persoFileRemove.hidden = false
      })
      panel.persoFileRemove.addEventListener('click', (e) => {
        e.preventDefault()
        state.personalization.file = null
        panel.persoFile.value = ''
        panel.persoFileLabel.textContent = '📎 Anexar arte (PNG, JPG, PDF, AI, PSD, SVG — até 20 MB)'
        panel.persoFileRemove.hidden = true
      })
    }
  }

  panel.cta.addEventListener('click', () => addToCart(state, data, panel))

  setupShipping(root, state, () => totalQty())

  panel.wa.addEventListener('click', () => track('whatsapp_click', { total_qty: totalQty() }))

  render()
}

function setupShipping(root, state, getTotal) {
  const wrapper = root.querySelector('[data-panel-shipping]')
  const zipInput = root.querySelector('[data-shipping-zip]')
  const btn = root.querySelector('[data-shipping-calc]')
  const result = root.querySelector('[data-shipping-result]')
  if (!wrapper || !zipInput || !btn || !result) return

  const data = JSON.parse(root.querySelector('#uniforme-config-data').textContent)
  const waNumber = data.labels.whatsappNumber || '5547984796022'
  let prefetchedProvince = null
  let prefetchedZip = ''

  function updateVisibility() {
    wrapper.hidden = getTotal() === 0
  }
  root.addEventListener('click', updateVisibility)
  root.addEventListener('input', updateVisibility)
  updateVisibility()

  zipInput.addEventListener('input', () => {
    const digits = zipInput.value.replace(/\D/g, '').slice(0, 8)
    zipInput.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits
    btn.disabled = digits.length !== 8
    if (!result.hidden) { result.hidden = true; result.innerHTML = '' }
    if (digits.length === 8 && digits !== prefetchedZip) {
      prefetchedZip = digits
      prefetchedProvince = null
      fetch(`https://viacep.com.br/ws/${digits}/json/`)
        .then(r => r.json())
        .then(cep => { if (digits === prefetchedZip) prefetchedProvince = cep.uf || '' })
        .catch(() => { prefetchedProvince = '' })
    }
  })

  btn.disabled = true

  btn.addEventListener('click', async () => {
    const digits = zipInput.value.replace(/\D/g, '')
    if (digits.length !== 8) return

    btn.disabled = true
    btn.textContent = 'Calculando...'
    result.hidden = false
    result.innerHTML = '<div class="uniforme-panel__shipping-loading">Consultando transportadoras...</div>'

    try {
      const items = buildFullCartItems(state, data)
      if (items.length === 0) throw new Error('Escolha os tamanhos primeiro')
      track('shipping_calc', { total_qty: items.reduce((s, i) => s + i.quantity, 0) })

      await fetch('/cart/clear.js', { method: 'POST' })
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      })
      if (!addRes.ok) throw new Error('Erro ao preparar cotação')

      let province = prefetchedProvince
      if (province == null || prefetchedZip !== digits) {
        try {
          const cep = await fetch(`https://viacep.com.br/ws/${digits}/json/`).then(r => r.json())
          province = cep.uf || ''
        } catch { province = '' }
      }

      const params = new URLSearchParams({
        'shipping_address[zip]': `${digits.slice(0, 5)}-${digits.slice(5)}`,
        'shipping_address[country]': 'BR'
      })
      if (province) params.set('shipping_address[province]', province)

      const rateRes = await fetch(`/cart/shipping_rates.json?${params}`)
      const body = await rateRes.json().catch(() => ({}))
      const rates = body.shipping_rates || []

      if (rates.length === 0) {
        result.innerHTML = `<p class="uniforme-panel__shipping-empty">Não conseguimos calcular o frete pra esse CEP.<br><a href="https://wa.me/${waNumber}" target="_blank" rel="noopener">Fale com um consultor</a></p>`
      } else {
        const rows = rates.map(r => {
          const isFree = parseFloat(r.price) === 0
          const price = isFree ? 'Grátis' : `R$ ${Number(r.price).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
          let deadline = ''
          if (r.delivery_days && r.delivery_days.length >= 2 && r.delivery_days[1] > 0) {
            deadline = r.delivery_days[0] === r.delivery_days[1]
              ? `${r.delivery_days[1]} dias úteis`
              : `${r.delivery_days[0]}–${r.delivery_days[1]} dias úteis`
          } else if (r.delivery_date) {
            const d = new Date(r.delivery_date + 'T12:00:00')
            deadline = `chega em ${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}`
          }
          return `<li><span class="uniforme-panel__shipping-name">${r.name}${deadline ? `<br><small>${deadline}</small>` : ''}</span><strong${isFree ? ' style="color:#1d7a3a"' : ''}>${price}</strong></li>`
        }).join('')
        result.innerHTML = `<button type="button" class="uniforme-panel__shipping-close" data-shipping-close aria-label="Fechar">×</button><ul class="uniforme-panel__shipping-list">${rows}</ul><p class="uniforme-panel__shipping-note">Valores estimados. O frete final aparece no checkout.</p>`
        result.querySelector('[data-shipping-close]').addEventListener('click', () => {
          result.hidden = true
          result.innerHTML = ''
        })
      }
    } catch (e) {
      result.innerHTML = `<p class="uniforme-panel__shipping-error">${e.message || 'Erro no cálculo.'}</p>`
    } finally {
      btn.disabled = false
      btn.textContent = 'Calcular'
    }
  })
}

function buildFullCartItems(state, data) {
  const items = buildCartItems(state)
  return items
}

function buildPersoItem(state, data, totalQty) {
  if (!state.personalization || !state.personalization.enabled) return null
  const variantId = totalQty >= data.personalization.breakQty
    ? Number(data.personalization.variantIdAbove)
    : Number(data.personalization.variantIdUpTo)
  if (!variantId) return null
  const properties = {}
  const desc = (state.personalization.description || '').trim()
  if (desc) properties['Observações'] = desc
  return {
    id: variantId,
    quantity: totalQty,
    properties
  }
}

function uploadWithProgress(url, formData, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', url)
    xhr.setRequestHeader('Accept', 'application/json')
    xhr.upload.addEventListener('progress', e => {
      if (e.lengthComputable && onProgress) onProgress(Math.round((e.loaded / e.total) * 100))
    })
    xhr.onload = () => {
      let json = {}
      try { json = JSON.parse(xhr.responseText) } catch {}
      const ok = xhr.status >= 200 && xhr.status < 300
      resolve({ ok, status: xhr.status, json })
    }
    xhr.onerror = () => reject(new Error('Erro de rede'))
    xhr.send(formData)
  })
}

async function addToCart(state, data, panel) {
  panel.error.hidden = true
  const items = buildFullCartItems(state, data)
  if (items.length === 0) return
  const totalQty = items.reduce((s, i) => s + i.quantity, 0)
  const persoItem = buildPersoItem(state, data, totalQty)
  const persoFile = state.personalization && state.personalization.file
  const originalCtaLabel = panel.cta.textContent

  track('add_to_cart_configurator', { total_qty: totalQty, item_count: items.length, has_perso: !!persoItem, has_file: !!persoFile })
  panel.cta.disabled = true
  panel.cta.textContent = 'Adicionando ao carrinho...'
  try {
    // 1. Adiciona todas as camisetas via JSON
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      throw new Error(err.description || 'Erro ao adicionar ao carrinho')
    }
    // 2. Adiciona a personalização (com upload de arquivo se houver)
    if (persoItem) {
      if (persoFile) {
        const fd = new FormData()
        fd.append('id', String(persoItem.id))
        fd.append('quantity', String(persoItem.quantity))
        for (const [k, v] of Object.entries(persoItem.properties)) {
          fd.append(`properties[${k}]`, v)
        }
        fd.append('properties[Arte do bordado]', persoFile)
        panel.cta.textContent = 'Enviando arte 0%…'
        const r2 = await uploadWithProgress('/cart/add.js', fd, pct => {
          panel.cta.textContent = pct < 100 ? `Enviando arte ${pct}%…` : 'Finalizando…'
        })
        if (!r2.ok) throw new Error(r2.json?.description || 'Erro no upload da arte')
      } else {
        panel.cta.textContent = 'Adicionando personalização…'
        const r2 = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [persoItem] })
        })
        if (!r2.ok) {
          const err = await r2.json().catch(() => ({}))
          throw new Error(err.description || 'Erro ao adicionar personalização')
        }
      }
    }
    panel.cta.textContent = 'Redirecionando…'
    window.location.href = '/cart'
  } catch (e) {
    panel.error.hidden = false
    panel.error.textContent = e.message || 'Erro. Tente novamente.'
    panel.cta.disabled = false
    panel.cta.textContent = originalCtaLabel || data.labels.ctaLabel
  }
}

document.querySelectorAll('[data-uniforme-configurator]').forEach(initConfigurator)
